import { Conditions } from '@vsolv/packages/conditions/domain';
import { Coverage } from '../../coverage';

export type CoverageRequirement = 'BASE' | 'NOT_APPLICABLE' | string;

/**
 * Constants for coverage requirement values
 */
export const CoverageRequirementValue = {
  BASE: 'BASE' as const,
  NOT_APPLICABLE: 'NOT_APPLICABLE' as const,
} as const;

// Base interface for required coverage config fields
export interface BaseCoverageConfig {
  coverageId: string;
  coverage?: Coverage.Model;
  requirement: Conditions.Rule<CoverageRequirement>;
  deductible: Conditions.Rule<number>;
  liabilityLimit: Conditions.Rule<number>;
  price: Conditions.Rule<number>;
  liabilityGroups: Conditions.Rule<string[]>;
}

// Interface for descriptive fields that can be dynamically added
export interface DescriptiveFields {
  sku?: Conditions.Rule<string>;
  skuDescription?: Conditions.Rule<string>;
  // Future extensibility: productCode?, category?, etc.
}

// Complete coverage config interface
export interface CoverageConfig extends BaseCoverageConfig, DescriptiveFields {}

// Type-safe way to access dynamic fields
export type DescriptiveFieldKey = keyof DescriptiveFields;

export interface PolicyTermCoverageConfigDto {
  termId: string;
  coverages: CoverageConfig[] | null;
}
